var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPersonnelWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_blanco",
    "data-name": "Logo blanco",
    xmlns: "http://www.w3.org/2000/svg",
    width: 182.559,
    height: 42.185,
    viewBox: "0 0 182.559 42.185",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2626",
    "data-name": "Group 2626",
    transform: "translate(45.03 6.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2625",
    "data-name": "Group 2625",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3847",
    "data-name": "Path 3847",
    d: "M664.111,429.287c-.17.081-.293.155-.425.2-.8.284-1.6.563-2.456.864a5.164,5.164,0,0,0-3.959-2.778,5.338,5.338,0,0,0-3.482.611,5.538,5.538,0,0,0-2.333,6.663,5.419,5.419,0,0,0,6.15,3.406c2.063-.331,3.76-2.292,3.652-3.683h-5.523c-.061-1-.029-1.92-.023-2.827a66.614,66.614,0,0,1,8.871-.089,8.77,8.77,0,0,1-.067,3.275,7.951,7.951,0,0,1-8.055,6.5,8.511,8.511,0,0,1-2.15-16.794,9.377,9.377,0,0,1,6.88,1.04A6.329,6.329,0,0,1,664.111,429.287Z",
    transform: "translate(-647.764 -423.575)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3848",
    "data-name": "Path 3848",
    d: "M931.568,419.04h3.027c.1,1.027.037,2.044.048,3.056.011.99,0,1.98,0,3.1.312-.153.511-.239.7-.344a6.116,6.116,0,0,1,9.286,5.053,6.828,6.828,0,0,1-.694,3.668,6.064,6.064,0,0,1-8.137,2.666c-.341-.152-.66-.35-1.044-.556l-.2.753h-2.941C931.446,435.808,931.39,420.412,931.568,419.04Zm9.946,11.429a3.367,3.367,0,0,0-2.33-3.532,3.43,3.43,0,0,0-4.289,2.232c-.659,2.234.274,4.025,2.132,4.677A3.306,3.306,0,0,0,941.514,430.469Z",
    transform: "translate(-890.614 -418.996)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3849",
    "data-name": "Path 3849",
    d: "M1524.263,440.029a9.474,9.474,0,0,1-1.057,4.774,5.984,5.984,0,0,1-5.758,3.313,5.84,5.84,0,0,1-5.45-3.661,10.109,10.109,0,0,1,.08-8.838c1.429-2.958,4.244-4.087,7.443-3.271a5.891,5.891,0,0,1,3.763,3.21A9.242,9.242,0,0,1,1524.263,440.029Zm-3.169.094a6.5,6.5,0,0,0-.719-3.41A2.934,2.934,0,0,0,1515,436.7a6.964,6.964,0,0,0-.758,3.656,6.355,6.355,0,0,0,.83,3.286,2.945,2.945,0,0,0,2.29,1.588,2.871,2.871,0,0,0,2.867-1.494A6.293,6.293,0,0,0,1521.094,440.123Z",
    transform: "translate(-1386.734 -430.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3850",
    "data-name": "Path 3850",
    d: "M1312.587,439.951a9.565,9.565,0,0,1-.751,4.149,6.294,6.294,0,0,1-9.1,3.015,6.528,6.528,0,0,1-2.768-3.63,10.781,10.781,0,0,1-.022-6.908,6.3,6.3,0,0,1,12.084-.214A9.5,9.5,0,0,1,1312.587,439.951Zm-3.143-.1a6.423,6.423,0,0,0-.784-3.348,2.914,2.914,0,0,0-2.6-1.674,2.956,2.956,0,0,0-2.687,1.68,6.62,6.62,0,0,0-.8,3.209,6.89,6.89,0,0,0,.8,3.734,2.924,2.924,0,0,0,2.336,1.654,2.821,2.821,0,0,0,2.717-1.286A6.526,6.526,0,0,0,1309.444,439.855Z",
    transform: "translate(-1205.57 -430.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3851",
    "data-name": "Path 3851",
    d: "M1418.807,439.287c-.069,2.536-.407,4.418-1.607,6.048a6.219,6.219,0,0,1-10.185-.2,7.945,7.945,0,0,1-1.3-3.509,11.009,11.009,0,0,1,.638-5.865,6.272,6.272,0,0,1,11.882.651A23.514,23.514,0,0,1,1418.807,439.287Zm-10.121.515c.094.694.141,1.4.3,2.079a5.568,5.568,0,0,0,.581,1.462,2.859,2.859,0,0,0,5.175.068,7.278,7.278,0,0,0-.033-7.233,2.773,2.773,0,0,0-1.412-1.274,2.843,2.843,0,0,0-3.444.982A6.764,6.764,0,0,0,1408.686,439.8Z",
    transform: "translate(-1296.48 -429.9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3852",
    "data-name": "Path 3852",
    d: "M1043.223,454.592l.116-.782h3.083v12.016h-3.067l-.127-.643a20.88,20.88,0,0,1-2.4.886,6,6,0,0,1-7.446-5.188,6.6,6.6,0,0,1,1.715-5.675,6.1,6.1,0,0,1,7.284-1.091C1042.638,454.247,1042.884,454.4,1043.223,454.592Zm-3.454,8.845a3.506,3.506,0,0,0,3.514-3.6,3.586,3.586,0,0,0-3.477-3.668,3.42,3.42,0,0,0-3.408,3.674A3.346,3.346,0,0,0,1039.769,463.438Z",
    transform: "translate(-977.799 -448.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3853",
    "data-name": "Path 3853",
    d: "M1208.42,443.184l2.8-.55c.1.32.179.595.271.865a2.772,2.772,0,0,0,4.18,1.405,2.057,2.057,0,0,0,.909-2.292,1.968,1.968,0,0,0-1.837-1.392c-.35-.028-.7-.011-1.055-.013-.32,0-.64,0-1.044,0a11,11,0,0,1,.01-2.492c.4,0,.772.012,1.143,0a6.707,6.707,0,0,0,1.134-.1,1.733,1.733,0,0,0,1.443-1.475,1.884,1.884,0,0,0-.827-1.992,2.622,2.622,0,0,0-3.908,1.281c-.113.327-.182.67-.286,1.056l-2.715-.556a4.885,4.885,0,0,1,1.489-3.433,5.9,5.9,0,0,1,8.038.169,4.879,4.879,0,0,1,.741,4.875,10.7,10.7,0,0,1-1.1,1.469s.013.074.055.1c2.326,1.263,1.983,5.061.089,6.633a6.039,6.039,0,0,1-4.529,1.278,5.4,5.4,0,0,1-3.74-1.723A4.81,4.81,0,0,1,1208.42,443.184Z",
    transform: "translate(-1127.7 -430.087)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3854",
    "data-name": "Path 3854",
    d: "M823.273,460.115a6.583,6.583,0,1,1,6.334,6.486A6.29,6.29,0,0,1,823.273,460.115Zm6.595,3.719a3.524,3.524,0,0,0,3.468-3.583,3.488,3.488,0,1,0-6.97-.051A3.517,3.517,0,0,0,829.868,463.834Z",
    transform: "translate(-798.002 -448.79)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3855",
    "data-name": "Path 3855",
    d: "M784.029,418.734h3.047v17.49h-2.958C783.9,435.552,783.825,420.365,784.029,418.734Z",
    transform: "translate(-764.309 -418.734)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3856",
    "data-name": "Path 3856",
    d: "M1148.512,419.105h3.05v17.383h-2.984C1148.389,435.856,1148.322,420.5,1148.512,419.105Z",
    transform: "translate(-1076.32 -419.052)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2628",
    "data-name": "Group 2628",
    transform: "translate(127.227 28.779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2627",
    "data-name": "Group 2627",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3857",
    "data-name": "Path 3857",
    d: "M1218.677,579.779h2.331c2.1,0,3.354.68,3.354,2.579,0,1.816-1.236,2.7-3.3,2.7h-1.742v3.98h-.646Zm2.225,4.73c1.89,0,2.795-.629,2.795-2.152,0-1.548-.938-2.034-2.851-2.034h-1.522v4.185Z",
    transform: "translate(-1218.677 -578.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M1265.367,599.6c0-2.2,1.43-3.553,2.941-3.553,1.6,0,2.582,1.138,2.582,3.121a2.861,2.861,0,0,1-.035.505H1266c.022,1.7,1.02,2.919,2.539,2.919a3.038,3.038,0,0,0,1.812-.6l.256.472a3.693,3.693,0,0,1-2.126.663C1266.763,603.132,1265.367,601.809,1265.367,599.6Zm4.938-.438c0-1.722-.781-2.579-1.992-2.579a2.516,2.516,0,0,0-2.312,2.579Z",
    transform: "translate(-1258.645 -592.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M1316.428,596.22h.525l.067,1.258h.031a2.342,2.342,0,0,1,1.918-1.427,1.409,1.409,0,0,1,.668.141l-.14.562a1.51,1.51,0,0,0-.609-.112c-.607,0-1.326.461-1.84,1.736v4.587h-.621Z",
    transform: "translate(-1302.354 -592.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M1341.422,602.2l.359-.452a3.12,3.12,0,0,0,2.144.854c1.062,0,1.612-.621,1.612-1.331,0-.845-.874-1.216-1.652-1.5-1.017-.361-2.149-.775-2.149-1.927,0-.972.77-1.795,2.174-1.795a3.163,3.163,0,0,1,1.927.7l-.334.447a2.567,2.567,0,0,0-1.61-.615c-1.052,0-1.528.605-1.528,1.228,0,.77.795,1.062,1.6,1.365,1.045.4,2.2.741,2.2,2.056a2.01,2.01,0,0,1-2.272,1.9A3.854,3.854,0,0,1,1341.422,602.2Z",
    transform: "translate(-1323.75 -592.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    d: "M1382.823,599.6c0-2.256,1.407-3.553,3.028-3.553s3.028,1.3,3.028,3.553c0,2.23-1.407,3.528-3.028,3.528S1382.823,601.835,1382.823,599.6Zm5.4,0c0-1.775-1.014-3.006-2.376-3.006s-2.376,1.23-2.376,3.006,1.014,2.98,2.376,2.98S1388.227,601.38,1388.227,599.6Z",
    transform: "translate(-1359.19 -592.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    d: "M1438.956,596.22h.525l.067,1.045h.031a3.309,3.309,0,0,1,2.32-1.213c1.393,0,2.039.845,2.039,2.587v4.326h-.621V598.72c0-1.43-.452-2.11-1.537-2.11-.8,0-1.385.424-2.2,1.267v5.087h-.621Z",
    transform: "translate(-1407.241 -592.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    d: "M1490.855,596.22h.526l.067,1.045h.031a3.309,3.309,0,0,1,2.32-1.213c1.393,0,2.039.845,2.039,2.587v4.326h-.621V598.72c0-1.43-.452-2.11-1.536-2.11-.8,0-1.385.424-2.2,1.267v5.087h-.621Z",
    transform: "translate(-1451.668 -592.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3864",
    "data-name": "Path 3864",
    d: "M1538.814,599.6c0-2.2,1.43-3.553,2.941-3.553,1.6,0,2.581,1.138,2.581,3.121a2.907,2.907,0,0,1-.035.505h-4.85c.022,1.7,1.02,2.919,2.539,2.919a3.039,3.039,0,0,0,1.812-.6l.255.472a3.692,3.692,0,0,1-2.126.663C1540.21,603.132,1538.814,601.809,1538.814,599.6Zm4.938-.438c0-1.722-.781-2.579-1.992-2.579a2.516,2.516,0,0,0-2.312,2.579Z",
    transform: "translate(-1492.723 -592.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3865",
    "data-name": "Path 3865",
    d: "M1589.874,583.087v-9.2h.621v9.283c0,.3.124.441.292.441a1.059,1.059,0,0,0,.253-.028l.1.505a1.4,1.4,0,0,1-.447.07C1590.155,584.16,1589.874,583.826,1589.874,583.087Z",
    transform: "translate(-1536.431 -573.888)",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2629",
    "data-name": "Group 2629"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3866",
    "data-name": "Path 3866",
    d: "M409.108,407.53l-3.69,10.874a8.377,8.377,0,0,0,1.464.618l2.779-8.189,5.107,6.6a8.288,8.288,0,0,0,1.117-1.142Zm12.3,15.908a7.41,7.41,0,0,0-1.273.94l4.453,5.759-6.787.707a7.324,7.324,0,0,0,.383,1.552l9.4-.978Zm-19.084,9.016L405,424.582a10.225,10.225,0,0,0-1.518-.462l-3.448,10.165,11.577-1.205a10.342,10.342,0,0,0-.312-1.559Z",
    transform: "translate(-390.667 -402.703)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3867",
    "data-name": "Path 3867",
    d: "M485.161,571.012l-6.578.684a10.334,10.334,0,0,0-.312-1.559l6.508-.677A7.324,7.324,0,0,0,485.161,571.012Z",
    transform: "translate(-457.643 -541.319)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3868",
    "data-name": "Path 3868",
    d: "M427.384,483.678l-1.886,5.56a10.216,10.216,0,0,0-1.518-.462l1.939-5.716A8.373,8.373,0,0,0,427.384,483.678Z",
    transform: "translate(-411.169 -467.358)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3869",
    "data-name": "Path 3869",
    d: "M509.032,475.544a7.417,7.417,0,0,0-1.273.94l-5.369-6.943a8.288,8.288,0,0,0,1.117-1.142Z",
    transform: "translate(-478.29 -454.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3870",
    "data-name": "Path 3870",
    d: "M423.7,382.35a8.351,8.351,0,1,1-8.351-8.35A8.308,8.308,0,0,1,423.7,382.35Z",
    transform: "translate(-396.634 -374)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3871",
    "data-name": "Path 3871",
    d: "M356.02,531.51a10.5,10.5,0,1,1-8.209-10.257,10.233,10.233,0,0,1,1.518.462,10.533,10.533,0,0,1,6.3,6.938,10.657,10.657,0,0,1,.393,2.856Z",
    transform: "translate(-335 -499.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3872",
    "data-name": "Path 3872",
    d: "M537.829,518.415a7.417,7.417,0,0,1-14.379,2.554,7.337,7.337,0,0,1-.383-1.552,7.415,7.415,0,1,1,14.762-1Z",
    transform: "translate(-495.933 -491.276)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPersonnelWhite);
export default __webpack_public_path__ + "static/media/logo_personnel_white.91039bd2a0cb495c3c9748347f8b4039.svg";
export { ForwardRef as ReactComponent };